var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.activeItem)?_c(_setup.componentFor(_setup.activeItem.type),{tag:"component",attrs:{"item":_setup.activeItem}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }